var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "general-header" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.resource("TouchpointStatistics_Overview_GeneralHeader")
                ) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.isLoadingStatistics
        ? [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("touchpoint-statistics-info-header", {
                  staticClass: "info-row",
                  attrs: {
                    "display-source": _vm.displaySourceHeader,
                    "display-selected": _vm.displayConditionHeader,
                    "display-destination": _vm.displayDestinationHeader
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.statistics, function(ref) {
              var connectionId = ref.connectionId
              var source = ref.source
              var condition = ref.condition
              var destination = ref.destination
              return [
                _c("touchpoint-statistics-overview-row", {
                  key: connectionId,
                  staticClass: "info-row",
                  attrs: {
                    "connection-id": connectionId,
                    "source-brick-name": source.label,
                    "source-brick-type": source.brickType,
                    "source-brick-config": source.brickConfig,
                    "display-source": source.display,
                    "source-amount": source.total,
                    "selected-name": condition.label,
                    "display-selected": condition.display,
                    "selected-amount": condition.total,
                    "destination-brick-name": destination.label,
                    "destination-brick-type": destination.brickType,
                    "destination-brick-config": destination.brickConfig,
                    "display-destination": destination.display,
                    "destination-amount": destination.total
                  }
                })
              ]
            })
          ]
        : _c("loading-box")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }